import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

import LessonInfo from '../LessonInfo/LessonInfo';
import MissingActivities from 'components/UI/MissingActivities/MissingActivities';
import classes from './CourseContent.module.css';

const CourseContent = props => {
  const { t } = useTranslation(['course']);
  return (
    <>
      <div className={classes.productLearnInfoSection}>
        <h2 className={classes.includesTitle}>{t('contents')}</h2>
        {props.accessCourse && <MissingActivities />}
        <aside className={classes.productContentItemsContainer}>
          {props.lessons.separators.map(separator => (
            <Accordion
              className={classes.productContentPanel}
              key={separator.separator.idSeparator}
            >
              <AccordionSummary
                className={classes.productContentTitle}
                expandIcon={
                  <ExpandMoreIcon
                    className={classes.productContentPanelIcon}
                  />
                }
              >
                <Typography
                  className={classes.productContentPanelTitle}
                >
                  {separator.separator.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                className={classes.lessonAcordionDetails}
              >
                {separator.lessons.map(lesson => (
                  <LessonInfo
                    key={lesson.idVideo}
                    data={lesson}
                    accessCourse={props.accessCourse}
                    userTrack={props.userTrack}
                  />
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
          {props.lessons.lessons.map(lesson => (
            <LessonInfo
              key={lesson.idVideo}
              data={lesson}
              accessCourse={props.accessCourse}
              userTrack={props.userTrack}
            />
          ))}
        </aside>
      </div>
    </>
  );
};

CourseContent.propTypes = {
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  userTrack: PropTypes.object
};

export default CourseContent;
